export enum ProductType {
  SimpleProduct,
  DigitalProduct,
  SubscriptionProduct,
  LogisticProduct,
}
